import React, { useState } from 'react'
import { useAtom } from 'jotai'
import { CaseDetail } from '../../../../models/CaseDetail'
import { Button } from '../../../ui/Button/Button'
import { Overlay } from '../../../ui/Sidebar'
import { RemindersHeaderInfo } from '../Reminders/Reminders'
import CaseFileCreateView from './CaseFileCreate'

import { profileAtom } from '../../../../api/profile/profile'
import { L } from '../../../providers/Lokalise'
import { RestrictElementWithTooltip } from '../RestrictElementWithTooltip'

type CreateFileOverlayProps = {
    caseDetails: CaseDetail
    onUpdated?: () => void
}

const CreateFileOverlay: React.FC<CreateFileOverlayProps> = ({
    caseDetails,
    onUpdated,
}): JSX.Element => {
    const [authProfile] = useAtom(profileAtom)
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            {!caseDetails?.isClosed && (
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <RestrictElementWithTooltip
                        restrictedAction={
                            !caseDetails?.allowedUpdateActionList.includes(
                                'Sagsbehandle'
                            )
                        }
                    >
                        <Button
                            type="primary"
                            onClick={() => setIsOpen(true)}
                            size="small"
                            style={{
                                width: 'fit-content',
                            }}
                            disabled={
                                !caseDetails?.allowedUpdateActionList.includes(
                                    'Sagsbehandle'
                                ) || authProfile.isImitator
                            }
                        >
                            {L('LØN_SAGS_FIL_SIDEBAR_TILFØJ_FIL_KNAP')}
                        </Button>
                    </RestrictElementWithTooltip>
                </div>
            )}

            <Overlay
                isShowing={isOpen}
                hide={() => {
                    setIsOpen(false)
                }}
            >
                <RemindersHeaderInfo
                    name={caseDetails?.newlyHired.name}
                    caseNumber={caseDetails?.caseNumber}
                />
                <CaseFileCreateView
                    caseDetails={caseDetails}
                    onUpdated={() => {
                        setIsOpen(false)
                        onUpdated?.()
                    }}
                    onCancel={() => setIsOpen(false)}
                    isOpen={isOpen}
                />
            </Overlay>
        </>
    )
}

export default CreateFileOverlay
